//
//
//
//
//
//
//

import iconMoment from '@/assets/icon/itemDetail/gift_share_ic_talk_normal@2x.png'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      iconMoment
    }
  },
  props: {
    showWord: {
      type: Boolean,
      default: true
    },
    type: {
      type: String
    },
    objectId: {
      type: Number
    },
    left: {
      type: Number
    },
    title: {
      type: String
    },
    desc: {
      type: String
    },
    image: {
      type: String
    },
    size: {
      type: Number,
      default: 66
    }
  },
  created () {
  },
  methods: {
    ...mapMutations({
      setNewMoment: 'setNewMoment'
    }),
    share () {
      this.$ga.trackEvent('moment_share', 'share', `${this.type}/${this.objectId}`)
      let object = {
        id: this.objectId,
        image: this.image,
        title: this.title,
        desc: this.desc,
        left: this.left
      }
      this.setNewMoment({
        type: this.type,
        object
      })
      this.$router.push(`/moment/release?type=${this.type}`)
    }
  }
}
